import { ImageInfo } from "./image/imageSlice";

export const INVALID_ID = "-1";

export enum EnabledEnum {
    YES          =  0,
    NO           =  1,
}
export function getEnabledEnumName(enabled?: number): string {
    if (enabled === undefined) {
        enabled = EnabledEnum.NO;
    }
    switch (enabled) {
        case EnabledEnum.YES:
            return "Ativa";
        default:
            return "Inativa";
    }
}

export enum ImageProcessorStyle {
    DIRECT          =  0,
	REVIEW_REQUIRED	=  1,
}
export function getImageProcessorStyleName(style?: ImageProcessorStyle): string {
    if(style === undefined) {
        style = ImageProcessorStyle.DIRECT;
    }
    switch (style) {
        case ImageProcessorStyle.DIRECT:
            return "Sem revisão";
        case ImageProcessorStyle.REVIEW_REQUIRED:
            return "Revisão obrigatória";
        default:
            return "Desconhecido";
    }
}


export enum LoadState {
    NotStarted = "NotStarted",
    Loading = "Loading",
    Loaded = "Loaded",
    Failed = "Failed",
}

export const notStarted = (): LoadStateInfo => {
    return {
        state: LoadState.NotStarted,
    };
};

export const loading = (): LoadStateInfo => {
    return {
        state: LoadState.Loading,
    };
};

export const loaded = (): LoadStateInfo => {
    return {
        state: LoadState.Loaded,
    };
};

export const error = (action: any): LoadStateInfo => {
    logThunkError(action);
    return {
        state: LoadState.Failed,
        code: action.payload?.status,
        error: action.payload?.statusText,
    };
};

export const failed = (code: string, error: string): LoadStateInfo => {
    return  {
        state: LoadState.Failed,
        code: code,
        error: error,
    };
};

export interface LoadStateInfo {
    state: LoadState;
    code?: string;
    error?: string;
}

export function worstState(list: LoadStateInfo[]): LoadStateInfo {
    let worst = loaded();
    for(const state of list) {
        if(state.state == LoadState.Failed) {
            if(worst.state != LoadState.Failed) {
                worst = state;
            } else {
                // get the higher failure code
                if(state.code && state.code > (worst.code || "000"))
                    worst = state;
            }

        } else if(state.state == LoadState.NotStarted) {
            if(!(worst.state == LoadState.Failed))
                worst = state;
        } else if(state.state == LoadState.Loading) {
            if(!(worst.state == LoadState.Failed || worst.state == LoadState.NotStarted))
                worst = state;
        } else if(state.state == LoadState.Loaded) {
            if(!(worst.state == LoadState.Failed || worst.state == LoadState.NotStarted || worst.state == LoadState.Loading))
                worst = state;
        } else {
            throw new Error(`ERR[unknown ${JSON.stringify(state)}]`);
        }
    }
    // console.log(`List: ${JSON.stringify(list)}, Worst: ${JSON.stringify(worst)}`);
    return worst;
}

export const getBackendUrl = () => {
    if(process.env.REACT_APP_BACKEND_URL) {
        return process.env.REACT_APP_BACKEND_URL;
    }
    return "/be";
};
export const getBackendTypstUrl = () => {
    if(process.env.REACT_APP_BACKEND_TYPST_URL) {
        return process.env.REACT_APP_BACKEND_TYPST_URL;
    }
    return "/typst";
};
export const getBaseUrl = () => {
    return `${process.env.PUBLIC_URL}`;
  };
export const getImagesUrl = () => {
    // console.log(`${JSON.stringify(process.env)}`);
    if(process.env.REACT_APP_IMAGES_URL) {
        return process.env.REACT_APP_IMAGES_URL;
    }
    return `${process.env.PUBLIC_URL}/images`;
};

export const getBackendPDFUrl = (id?: number|string): string => {
    return `${getBackendUrl()}/api/file/${id}`;
};
export const getBackendImagesUrl = (image?: ImageInfo): string => {
    return `${getBackendUrl()}/api/image/${image?.id}`;
};
export const getBackendThumbnailUrl = (image?: ImageInfo): string => {
    return `${getBackendUrl()}/api/thumbnail/${image?.id}`;
};
export const assertImagesUrl = (url?: string| null): string => {
    return assertUrl("image", url);
};
export const assertThumbnailUrl = (url?: string | null): string => {
    return assertUrl("thumbnail", url);
};
const assertUrl = (source: string, url?: string | null): string => {
    if(!url)
        return `${getImagesUrl()}/no-image.wbep`;
    if(url.startsWith("ml:"))
        return `${getBackendUrl()}/api/${source}/${url.substring(3)}`;
    return url;
};

export interface HTTPFailedResponse {
    status: number;
    statusText: string;
}
  
export const failedResponse = (response: Response): HTTPFailedResponse => {
  /*
  body: (...)
  bodyUsed: false
  headers: 
  Headers {}
  ok: false
  redirected: false
  status: 403
  statusText: "Forbidden"
  type: "cors"
  url: "http://localhost:8080/be/api/student/10"
  */
    return {
      status: response.status,
      statusText: response.statusText,
    };
};
  
export const logThunkError = (action: any) => {
    console.error(JSON.stringify(action));
};
  
export const isoToBrt = (date: string | undefined): string => {
    if (!date) return "";
    if(date.indexOf("-") > 0) {
        return date.split("-").reverse().join("/");
    }
    return date;
};

export const brtToIso = (date: string | undefined): string => {
    if (!date) return "";
    if(date.indexOf("/") > 0) {
        return date.split("/").reverse().join("-");
    }
    return date;
};

export const getImageStatusColor = (status?: number): string => {
    switch(status) {
        case 0: return "green";       // pending
        case 1: return "red";       // processing
        case 2: return "blue";      // ready
        case 3: return "yellow";        // failed
        default: return "black";     // unknown
    }
};